/* eslint-disable no-console */
const VAPID_PUBLIC_KEY = 'BNuriZzzHzaWv8jfelB1HTNyTnH_bp7ixVTxsKdL87yqYQwjaq3lHCQhFR4xwLo9Oi-OHvvNmKjAZpAcHjDLhSo';
import store from './store'

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

let refreshing = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

  const rawData = atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}

/**
 * Requests push notification permission and registers the subscription with the backend.
 *
 * iOS-specific fix: After requestPermission() is granted, pushManager.getSubscription()
 * may return null for a short time while the service worker takes control.
 * We retry up to 5 times with increasing delays before giving up.
 *
 * @returns {boolean} true if subscription was successfully sent to backend, false otherwise.
 */
export default async function registerPushWorker() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push-Benachrichtigungen werden nicht unterstützt.');
    return false;
  }

  try {
    // Wait for service worker to be ready and controlling the page
    const registration = await navigator.serviceWorker.ready;
    console.log('✅ Service Worker registriert:', registration);

    // Request permission if not already granted
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('🔒 Benachrichtigungsberechtigung nicht erteilt.');
      return false;
    }

    // iOS fix: Retry loop - getSubscription() can return null right after permission grant
    // while the browser is still setting up the push subscription internally.
    let subscription = null;
    const MAX_ATTEMPTS = 5;

    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
          // No existing subscription → create one
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
          });
        }

        if (subscription) {
          console.log(`📬 Subscription erhalten (Versuch ${attempt}):`, subscription);
          break; // success
        }
      } catch (e) {
        console.warn(`⚠️ Subscription-Versuch ${attempt}/${MAX_ATTEMPTS} fehlgeschlagen:`, e.message);
      }

      if (attempt < MAX_ATTEMPTS) {
        // Exponential backoff: 500ms, 1000ms, 1500ms, 2000ms
        await new Promise(resolve => setTimeout(resolve, attempt * 500));
      }
    }

    if (!subscription) {
      console.error('❌ Konnte keine Push-Subscription erstellen nach', MAX_ATTEMPTS, 'Versuchen.');
      return false;
    }

    // Send subscription to backend
    await fetch(
      process.env.NODE_ENV === 'production'
        ? 'https://teamup-api.jobjournal.io/api/subscribe'
        : 'http://localhost:3001/api/subscribe',
      {
        method: 'POST',
        body: JSON.stringify(subscription),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${store.state.token}`,
        },
      }
    );

    console.log('✅ Subscription erfolgreich an Backend gesendet.');
    return true;
  } catch (error) {
    console.error('❌ Fehler bei der Push-Registrierung:', error);
    return false;
  }
}
